import type { KanbanBoard } from '@qlk/shared';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

import { TheVideo } from './TheVideo.js';

export type CotBang = KanbanBoard['columns'][number];

export interface CotKanbanProps {
  cot: CotBang;
  onMo: (id: string) => void;
  /** Ngày đăng thật theo `productionItem.id`, lấy từ lịch của module 06. */
  ngayDang?: Map<string, string>;
}

export function CotKanban({ cot, onMo, ngayDang }: CotKanbanProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: `cot-${cot.stage}`,
    data: { stage: cot.stage },
  });

  return (
    <section
      aria-label={cot.label}
      className={`flex w-[280px] shrink-0 flex-col rounded-the border bg-nen p-3 ${
        isOver ? 'border-nhan' : 'border-vien'
      }`}
    >
      <header className="mb-3 flex items-center justify-between gap-2">
        <h2 className="flex items-center gap-2 text-co-ban font-semibold text-chu">
          <span
            className="inline-block size-2 rounded-full"
            style={{ backgroundColor: cot.color }}
            aria-hidden="true"
          />
          {cot.label}
        </h2>
        <span className="so-lieu rounded-full bg-be-mat px-2 py-0.5 text-phu font-medium text-chu-phu">
          {cot.count}
        </span>
      </header>

      <div ref={setNodeRef} className="flex min-h-[120px] flex-col gap-3">
        <SortableContext items={cot.items.map((i) => i.id)} strategy={verticalListSortingStrategy}>
          {cot.items.map((item) => (
            <TheVideo
              key={item.id}
              item={item}
              onMo={onMo}
              ngayDang={ngayDang?.get(item.id) ?? null}
            />
          ))}
        </SortableContext>

        {cot.items.length === 0 && (
          <p className="rounded-xl border border-dashed border-vien px-3 py-6 text-center text-phu text-chu-mo">
            Chưa có thẻ nào
          </p>
        )}
      </div>
    </section>
  );
}
